export default __webpack_public_path__ + "static/scalpel-5c7e1b855fa192c585e74ffb84e67075.png";